<template>
  <div>
    <div class="public-table-but__left">
      <div class="item">
        <div class="item-wp">
          <template>
            <div class="item-son">
              <el-input
                  v-model="listParams.searchValue"
                  placeholder="搜索关键词"
                  clearable
                  @keyup.enter.native="SearchQuestionBankList"
              ></el-input>
            </div>
            <div class="item-son">
              <el-select
                  v-model="dictDataSelect"
                  placeholder="请选择分类"
                  ref="selectReport"
                  style="width: 100%"
                  clearable
              >
                <el-option
                    :value="listParams.examCategoryId"
                    :label="listParams.examCategoryId"
                    style="height: auto"
                >
                  <el-tree
                      :data="selectData"
                      :props="treeProps"
                      :render-after-expand="true"
                      :expand-on-click-node="false"
                      @node-click="handleNodeClick"
                  ></el-tree>
                </el-option>
              </el-select>
            </div>
            <div class="item-son">
              <el-select
                  v-model="listParams.status"
                  clearable
                  placeholder="请选择状态"
              >
                <el-option label="正常" :value="1"></el-option>
                <el-option label="禁用" :value="0"></el-option>
              </el-select>
            </div>
            <div class="item-son">
              <el-button type="primary" @click="SearchQuestionBankList"
              >查询 <i class="el-icon-search"></i>
              </el-button>
            </div>
          </template>
          <div class="item-son">
            <el-button type="primary" @click="handleClick('add')"
            >新增 <img src="@assets/images/add-icon.png" alt=""/>
            </el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="public-table-data">
      <el-table
          ref="multipleTable"
          size="medium"
          :data="tableData"
          border
          style="width: 100%"
          row-key="menuId"
          v-loading="loading"
      >
        <el-table-column fixed="left" type="index" label="序号" width="60" align="center">
        </el-table-column>
        <el-table-column
            fixed="left"
            prop="name"
            label="名称"
            min-width="230"
            align="center"
        >
        </el-table-column>
        <el-table-column prop="code" label="标识" width="150" align="center">
        </el-table-column>
        <el-table-column
            prop="examCategoryName"
            label="分类"
            width="150"
            align="center"
        ></el-table-column>
        <el-table-column
            prop="categoryName"
            label="章节"
            width="180"
            align="center"
        >
          <template slot-scope="scope">
            <div>章节：{{ scope.row.chapter }}</div>
            <div>页数：{{ scope.row.pageCount }}</div>
          </template>
        </el-table-column>
        <el-table-column
            prop="categoryName"
            label="数据"
            width="180"
            align="center"
        >
          <template slot-scope="scope">
            <div>参与：{{ changeShowTxt(scope.row.otherInfo).answers }}</div>
            <div>购买：{{ changeShowTxt(scope.row.otherInfo).buys }}</div>
          </template>
        </el-table-column>
        <el-table-column
            prop="price"
            label="价格"
            width="120"
            align="center"
        >
          <template slot-scope="scope">
            {{ `￥ ${formatMinNum(scope.row.price)}` }}
          </template>
        </el-table-column>
        <el-table-column prop="code" label="状态" width="100" align="center">
          <template slot-scope="scope">
            <el-switch
                v-model="scope.row.status"
                :active-value="1"
                :inactive-value="0"
                @change="changeSwitch(scope.row)"
            >
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column
            prop="ctime"
            label="上架时间"
            width="180"
            align="center"
        >
        </el-table-column>
        <el-table-column fixed="right" label="操作" align="center" width="180">
          <template slot-scope="scope">
            <el-button
                style="margin-bottom: 10px"
                size="mini"
                @click="handleClick('edit', scope.row)"
                type="success"
                plain
            >编辑
            </el-button
            >
            <el-button
                size="mini"
                @click="handleDelete(scope.row)"
                type="danger"
                plain
            >删除
            </el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <!-- 分页 -->
      <div class="public-pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pages.pageNo"
            :page-sizes="[PAGE_SIZE, 50, 100, 200, 400]"
            :page-size="pages.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 编辑弹框 -->
    <el-dialog
        title="新增/编辑课程信息"
        :visible.sync="dialogVisible"
        width="860px"
        top="30px"
        :close-on-click-modal="false"
        class="public-dialog"
    >
      <div class="public-dialog-form"  v-loading="loading">
        <el-form
            ref="ruleForm"
            :rules="rules"
            :model="params"
            label-width="80px"
        >
          <el-form-item prop="paymentType" label="分类">
            <el-select
                v-model="dictDataSelect1"
                placeholder="请选择分类"
                ref="selectReport"
                style="width: 100%"
                clearable
            >
              <el-option
                  :value="params.examCategoryId"
                  :label="params.examCategoryId"
                  style="height: auto"
              >
                <el-tree
                    :data="selectData"
                    :props="treeProps"
                    :render-after-expand="true"
                    :expand-on-click-node="false"
                    @node-click="handleNodeClick1"
                ></el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <el-row>
            <el-col :span="12">
              <el-form-item label="列表图">
                <div class="diplay" style="margin-right: 10px">
                  <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcList"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 75px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicy"
                  />
                </span>
                    <div
                        class="up-btn"
                        style="width: 75px; height: 75px; line-height: 80px"
                        @click="getPolicy"
                        v-if="isMoer"
                    >
                      <i class="el-icon-plus"></i>
                    </div>
                  </div>
                  <input
                      type="file"
                      ref="file"
                      @change="getFile"
                      accept="image/png,image/jpg"
                  />
                </div>
                <div class="diplay" style="margin-right: 50px">
                  <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcListLang"
                    :key="index"
                    class="slideshow"
                >
                  <el-image
                      style="width: 150px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicyLang"
                  />
                </span>
                    <div
                        class="up-btn"
                        style="width: 150px; height: 75px; line-height: 80px"
                        @click="getPolicyLang"
                        v-if="isMoerLang"
                    >
                      <i class="el-icon-plus"></i>
                    </div>
                  </div>
                  <input
                      type="file"
                      ref="fileLang"
                      @change="getFileLang"
                      accept="image/png,image/jpg"
                  />
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="视频">
                <div class="diplay">
                  <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcListVideo"
                    :key="index"
                    class="slideshow"
                >
                  <div @click="getPolicyVideo">
                    <video
                        width="100%"
                        controls="controls"
                        style="width: 75px; height: 75px; border-radius: 6px"
                    >
                      <source :src="imgUrl" type="video/mp4"/>
                    </video>
                  </div>
                </span>
                    <div
                        class="up-btn"
                        style="width: 75px; height: 75px; line-height: 80px"
                        @click="getPolicyVideo"
                        v-if="isMoerVideo"
                    >
                      <i class="el-icon-plus"></i>
                    </div>
                  </div>
                  <input
                      type="file"
                      ref="fileVideo"
                      @change="getFileVideo"
                      accept="video/*"
                  />
                </div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="轮播图">
                <div class="diplay" style="margin-right: 10px">
                  <div class="screenshot">
                <span
                    v-for="(imgUrl, index) in srcListBanner"
                    :key="index"
                    class="slideshow"
                >
                  <div class="icon-close" @click="removeUploading(index)">
                    <i class="el-icon-close"></i>
                  </div>
                  <el-image
                      style="width: 75px; height: 75px; border-radius: 6px"
                      :src="imgUrl"
                      fit="cover"
                      @click="getPolicyBanner"
                  />
                </span>
                    <div
                        class="up-btn"
                        style="width: 75px; height: 75px; line-height: 80px"
                        @click="getPolicyBanner"
                    >
                      <i class="el-icon-plus"></i>
                    </div>
                  </div>
                  <input
                      type="file"
                      ref="fileBanner"
                      @change="getFileBanner"
                      accept="image/png,image/jpg"
                  />
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="PDF文件">
                <input
                    class="input_box"
                    type="file"
                    style="display: inline-block;height: auto;padding: 0;border: 0"
                    ref="txt_file"
                    @change="getTxtFile"
                    accept="*"
                    id="files_name"
                />
              </el-form-item>
              <el-form-item label="PDF文件" v-if="params.accessoryUrl">
                <a target="_blank" :href="params.accessoryUrl">预览</a>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="名称" prop="name">
                <el-input
                    placeholder="请填写名称"
                    v-model="params.name"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="标识" prop="code">
                <el-input
                    placeholder="请填写标识"
                    v-model="params.code"
                    :disabled="clickType=='edit'"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="价格" prop="price">
                <el-input
                    placeholder="请填写支付价"
                    v-model="params.price"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="支付说明">
            <el-input
                placeholder="请填写支付说明"
                v-model="params.payDesc"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="主题" prop="topic">
            <el-input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 4 }"
                placeholder="请填写主题"
                v-model="params.topic"
            >
            </el-input>
          </el-form-item>
          <el-row type="flex">
            <el-col :span="9">
              <el-form-item label="章节" prop="chapter">
                <el-input
                    placeholder="请填写章节"
                    v-model="params.chapter"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item label="页数" prop="pageCount">
                <el-input
                    placeholder="请填写页数"
                    v-model="params.pageCount"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="VIP免费">
                <el-switch
                    v-model="params.vipFree"
                    :active-value="1"
                    :inactive-value="0"
                >
                </el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row type="flex">
            <el-col :span="9">
              <el-form-item label="参与人数">
                <el-input
                    placeholder="请填写参与人数"
                    v-model="params.answers"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="9">
              <el-form-item label="购买人数">
                <el-input
                    placeholder="请填写购买人数"
                    v-model="params.buys"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="详情">
            <richText :keyWord="'remark'" :params="params" v-if="flag"></richText>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="public-dialog-footer">
        <el-button size="medium" @click="dialogVisible = false"
        >取 消</el-button
        >
        <el-button size="medium" type="primary" @click="handleEdit"
        >提 交</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import richText from "../../components/richText.vue";
import {PAGE_SIZE} from "@config";
import {emptyShow, formatMinNum} from "@utils/tools/index";
import {ossUpload} from "@utils/filters/upload";

export default {
  components: {
    richText,
  },
  computed: {},
  data() {
    return {
      params: {
        vipFree: 0,
      },
      tableData: [],
      emptyShow,
      formatMinNum,
      dialogVisible: false,
      total: 0,
      PAGE_SIZE,
      loading: false,
      pages: {
        pageNo: 1,
        pageSize: PAGE_SIZE,
      },
      srcList: [],
      isMoer: true,
      srcListLang: [],
      isMoerLang: true,
      srcListVideo: [],
      isMoerVideo: true,
      srcListBanner: [],
      isMoerBanner: true,
      clickType: "",
      listParams: {},
      rules: {
        name: [{required: true, message: "请填写名称", trigger: "blur"}],
        code: [{required: true, message: "请填写标识", trigger: "blur"}],
        price: [
          {required: true, message: "请填写支付价", trigger: "blur"},
        ],
        pageCount: [{required: true, message: "请填写页数", trigger: "blur"}],
        chapter: [{required: true, message: "请填写章节", trigger: "blur"}],
      },
      flag: false, //销毁子组件
      dictDataSelect: "",
      dictDataSelect1: "",
      selectData: [],
      treeProps: {
        //配置选项:此处定义el-tree的label和children为指定属性，  如果不定义取默认，即label和children
        value: "parentId",
        children: "examCategoryVos",
        label: "name",
      },
    };
  },
  created() {
    this.queryTableData();
    this.classifyData()
  },
  watch: {
    dialogVisible() {
      if (this.dialogVisible == false) {
        this.$refs["ruleForm"].resetFields();
        this.params = {};
        var file = document.getElementById('files_name');
        file.value = ''
        /* 以下：清空所有图片  */
        this.srcList = [];
        this.isMoer = true;
        this.srcListLang = [];
        this.isMoerLang = true;
        this.srcListVideo = "";
        this.isMoerVideo = true;
        this.srcListBanner = [];
        this.isMoerBanner = true;
      }
    },
  },
  methods: {
    changeShowTxt(data) {
      return JSON.parse(data)
    },
    async getTxtFile() {
      const that = this;
      this.loading = true
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.txt_file.files[0],
          resData.data,
          "one", //'more','one'
      );
      this.params.accessoryUrl = addRoutes[0];
      this.$message.success('上传成功')
      this.loading = false
    },
    handleNodeClick1: function (node) {
      this.dictDataSelect1 = node.name;
      this.params.categoryId = node.categoryId;
      this.$refs.selectReport.blur();
    },
    handleNodeClick: function (node) {
      this.dictDataSelect = node.name;
      this.listParams.categoryId = node.categoryId;
      if (node.parentId == 0) {
        this.listParams.parentId = node.categoryId;
      } else {
        this.listParams.parentId = node.categoryId;
      }
      if (node.id != 0) {
        //this.AccountData.orgId = node.id;
      }
      this.$refs.selectReport.blur();
    },
    /**
     * 获取分类列表
     */
    async classifyData() {
      this.loading = true;
      const {data: resData} = await this.$get("/exam/category/list", {
        params: {
          status: 1,
          paging: false,
          tree: true,
        },
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.selectData = resData.data.sort(function (a, b) {
        return b.seq - a.seq;
      });
    },
    SearchQuestionBankList() {
      this.pages.pageNo = 1
      this.queryTableData()
    },
    /**
     * 获取列表
     */
    async queryTableData() {
      this.loading = true;
      const {data: resData} = await this.$post("/course/list/search", {
          ...this.listParams,
          ...this.pages,
      });
      this.loading = false;
      if (resData.result != 200) return;
      this.tableData = resData.data;
      this.total = resData.page.count;
    },
    /**
     * 修改评测题库状态
     */
    async changeSwitch(b) {
      const {data: resData} = await this.$get(
          `/course/updateStatus/${b.id}`
      );
      this.loading = false;
      if (resData.result != 200) return;
      this.$message({
        message: resData.message,
        type: "success",
      });
    },
    /**
     * 图片上传的内容
     */
    getPolicy() {
      this.$refs.file.dispatchEvent(new MouseEvent("click"));
    },
    async getFile() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.file.files[0],
          resData.data,
          "one", //'more','one'
          this.srcList
      );
      this.isMoer = false;
      this.srcList = addRoutes;
      this.params.listImage1 = this.srcList[0];
    },

    getPolicyLang() {
      this.$refs.fileLang.dispatchEvent(new MouseEvent("click"));
    },
    async getFileLang() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.fileLang.files[0],
          resData.data,
          "one", //'more','one'
          this.srcListLang
      );
      this.isMoerLang = false;
      this.srcListLang = addRoutes;
      this.params.listImage2 = this.srcListLang[0];
    },

    getPolicyVideo() {
      this.$refs.fileVideo.dispatchEvent(new MouseEvent("click"));
    },
    async getFileVideo() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });
      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.fileVideo.files[0],
          resData.data,
          "one", //'more','one'
          this.srcListVideo
      );
      this.isMoerVideo = false;
      this.srcListVideo = addRoutes;

      this.params.video = this.srcListVideo[0];
    },

    getPolicyBanner() {
      this.$refs.fileBanner.dispatchEvent(new MouseEvent("click"));
    },
    async getFileBanner() {
      const that = this;
      const {data: resData} = await this.$get("/aliyun/oss/sign", {
        headers: {
          isLoading: true,
        },
      });

      if (resData.result != 200) return;
      const addRoutes = await ossUpload(
          that.$refs.fileBanner.files[0],
          resData.data,
          "more", //'more','one'
          this.srcListBanner
      );
      this.isMoerBanner = false;
      this.srcListBanner = addRoutes;
      this.params.slideshowImageList = this.srcListBanner;
    },

    removeUploading(index) {
      this.srcListBanner.splice(index, 1);
      this.params.slideshowImageList = this.srcListBanner;
    },
    /**
     * 表格按钮点击
     */
    async handleClick(type, row) {
      this.clickType = type;
      if (type == "edit") {
        this.srcListLang = [];
        this.srcList = [];
        this.isMoer = true;
        this.isMoerLang = true;

        let temp = row;
        if (emptyShow(temp.listImage1)) {
          this.srcList.push(temp.listImage1);
          this.isMoer = false;
        }
        if (emptyShow(temp.listImage2)) {
          this.srcListLang.push(temp.listImage2);
          this.isMoerLang = false;
        }
        if (emptyShow(temp.slideshowImageList)) {
          this.srcListBanner = temp.slideshowImageList;  //轮播图
          this.isMoerBanner = true;
        }
        if (emptyShow(temp.video)) {
          this.video = temp.video;  //视频
          this.isMoerVideo = false;
        }
        this.flag = false;
        this.$nextTick(() => {
          this.flag = true;  //组件生命重新加载
        });

        let newarr = JSON.parse(JSON.stringify(temp));
        newarr.price = temp.price / 100
        this.params = newarr
        newarr.otherInfo = JSON.parse(newarr.otherInfo)
        this.params.answers = newarr.otherInfo.answers
        this.params.buys = newarr.otherInfo.buys
        this.dictDataSelect1 = temp.categoryName;
        this.dialogVisible = true;
      } else if (type == "add") {
        this.flag = false;
        this.$nextTick(() => {
          this.flag = true;  //组件生命重新加载
        });
        this.dialogVisible = true;
      }
    },
    /**
     * 编辑/新增
     */
    handleEdit() {
      this.$refs.ruleForm.validate((valid) => {
        if (!valid) return;
        this.$confirm("确认保存数据, 是否继续?", "提示", {
          type: "info",
        }).then(async () => {
          let b = (this.params.price) * 100
          let c = b.toFixed(1)
          this.params.price = parseInt(c);
          this.params.examCategoryName = this.dictDataSelect1
          this.params.otherInfo = {
            answers: this.params.answers,
            buys: this.params.buys
          }
          this.params.otherInfo = JSON.stringify(this.params.otherInfo)
          const {data: resData} = await this.$post(
              "/course/save",
              this.params,
              {
                headers: {
                  isLoading: true,
                },
              }
          );
          if (resData.result != 200) return;
          this.queryTableData();
          this.dialogVisible = false;
          this.$message.success("添加成功!");
          this.params = {};
        });
      });
    },
    /**
     * 删除
     */
    handleDelete(row) {
      this.$confirm("此操作将永久删除数据, 是否继续?", "提示", {
        type: "warning",
      }).then(async () => {
        const {data: resData} = await this.$get(
            `/course/delete/${row.id}`,
            {
              headers: {
                isLoading: true,
              },
            }
        );
        if (resData.result != 200) return;
        this.queryTableData();
        this.$message.success("删除成功!");
      });
    },
    /**
     *  分页长度改变
     */
    handleSizeChange(val) {
      this.pages.pageNo = 1;
      this.pages.pageSize = val;
      this.queryTableData();
    },
    /**
     *  下一页
     */
    handleCurrentChange(val) {
      this.pages.pageNo = val;
      this.queryTableData();
    },
  },
};
</script>
<style lang="scss" scoped>

.item_info {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.name_left {
  width: 60px;
  text-align: right;
}

.diplay {
  display: inline-block;
}

.screenshot {
  display: inline-block;
  vertical-align: text-top;
}

.video-label {
  margin-right: 15px;
}

.item-add {
  margin: 15px 0;

  .el-button {
    margin-bottom: 15px;
  }

  .el-button img {
    max-height: 12px;
  }
}

.style_box {
  display: flex;
  flex-wrap: wrap;
}

.style-outer {
  background: #fff;
  //float: left;
  margin: 0 20px 20px 0;
  width: 108px;
  //height: 110px;
  border: 1px solid #ddd;
  cursor: pointer;
  position: relative;

  .style__font {
    padding: 0 5px;
    line-height: 1.5;
    //line-height: 5px;
    //margin: 0 0 0 10px;
  }

  .isCheck {
    position: absolute;
    top: 0;
    right: 5px;
    z-index: 2;

    .el-icon-success {
      font-size: 20px;
      color: #ddd;
    }
  }
}

.active_class {
  // border: 1px solid #000 !important;
  color: #67c23a !important;
}
</style>
